import { AnimatePresence, motion } from 'framer-motion';
import { formatDate } from '../../utils/format-date';
import { itemVariants, containerVariants } from '../../utils/physical-stagger-animation';
import { fadeInOut, titleAnimation } from './animations';
import { useCalendarDays } from '../../hooks/useCalendarDays';
import { CalendarDropdown } from './CalendarDropdown';
import { hasDatePassed } from '../../utils/has-date-passed';
import { classNames } from '@/utils/class-names';

export const CalendarDays = () => {
  const { monthsGroupped } = useCalendarDays();

  return (
    <div className="flex flex-col gap-12">
      <AnimatePresence mode="wait">
        {monthsGroupped.map((monthData) => {
          return (
            <motion.div key={monthData.month} {...fadeInOut}>
              <motion.h3 {...titleAnimation} className="mb-6 text-center font-cadiz text-sh-24 font-bold">
                {monthData.month}
              </motion.h3>
              <motion.div
                variants={containerVariants}
                initial="hidden"
                animate="visible"
                className="flex flex-wrap justify-center gap-4">
                {monthData.events.map((day, index) => {
                  const hasRelatedContent = day?.related_resource;
                  const isPodcast = hasRelatedContent && !day?.related_resource;
                  const hasPassed = hasDatePassed(day);
                  const slug = day?.related_resource?.slug;
                  const link = isPodcast ? `/podcast/${slug}` : `/resource-hub/resource/${slug}`;

                  return (
                    <motion.div
                      key={`${day.name}-${day.startDate}`}
                      variants={itemVariants}
                      custom={index}
                      className={classNames(
                        'w-full gap-1 rounded-2xl border bg-white  p-3 md:w-[190px]',
                        hasPassed ? 'border-[#868A8E]' : 'border-[#A1C4ED]',
                      )}>
                      <div className="flex justify-center">
                        <div
                          className={classNames(
                            'mb-1 rounded-2xl border border-[#EEEEEE] px-3 py-1 text-center text-sh-xxs',
                            hasPassed ? 'text-[#868A8E]' : '',
                          )}>
                          <div>{formatDate(day)}</div>
                        </div>
                      </div>
                      <div>
                        <div className={classNames('text-center', hasPassed ? 'text-[#868A8E]' : '')}>
                          <span className="text-center font-cadiz text-sh-sm">{day.name}</span>
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          {!hasPassed && <CalendarDropdown event={day} />}
                          {hasRelatedContent && (
                            <button
                              className="!my-0 font-cadiz text-sh-xxxs font-bold hover:text-blue-500"
                              onClick={() => window.open(link, '_blank')}>
                              related content
                            </button>
                          )}
                        </div>
                      </div>
                    </motion.div>
                  );
                })}
              </motion.div>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
};
